<template>
  <button
    type="button"
    class="tad-check-box"
    :class="{
      'tad-check-box--checked': modelValue,
      'tad-check-box--disabled': disabled,
    }"
    :aria-checked="modelValue"
    :aria-label="ariaLabel"
    :disabled="disabled"
    role="checkbox"
    @click="toggle"
  >
    <v-icon v-if="modelValue" icon="mdi-check" size="14" />
  </button>
</template>

<script>
export default {
  name: "TicketActionCheckbox",

  props: {
    modelValue: { type: Boolean, default: false },
    ariaLabel: { type: String, default: "Toggle option" },
    disabled: { type: Boolean, default: false },
  },

  emits: ["update:modelValue"],

  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit("update:modelValue", !this.modelValue);
    },
  },
};
</script>
